import { Injectable } from "@angular/core";

import {
  CustomQueryParamsHandling,
  Page,
  QueryStringParameterKey,
} from "../routes/shared/shared-route.constant";

import { ProductService } from "./product.service";
import { UrlService } from "./url.service";

@Injectable({
  providedIn: "root",
})
export class SignDocumentUrlService {
  constructor(
    private readonly _urlService: UrlService,
    private readonly _productService: ProductService,
  ) {}

  createSuccessExitPointUrl() {
    const product = this._productService.getProduct();

    const urlSearchParams = new URLSearchParams({
      [QueryStringParameterKey.APPLICATION_ID]:
        SignDocumentUrlVariables.APPLICATION_ID,
    });

    const successExitPointUrl = this._urlService.createAbsoluteUrlByPage(
      product,
      Page.APPLICATION_DIGITAL_SIGNATURE_SUCCESS,
      CustomQueryParamsHandling.REPLACE,
      urlSearchParams,
    );

    return successExitPointUrl;
  }

  createErrorExitPointUrl() {
    const product = this._productService.getProduct();

    const urlSearchParams = new URLSearchParams({
      [QueryStringParameterKey.APPLICATION_ID]:
        SignDocumentUrlVariables.APPLICATION_ID,
    });

    const errorExitPointUrl = this._urlService.createAbsoluteUrlByPage(
      product,
      Page.APPLICATION_DIGITAL_SIGNATURE_ERROR,
      CustomQueryParamsHandling.REPLACE,
      urlSearchParams,
    );

    return errorExitPointUrl;
  }

  createDeclineExitPointUrl() {
    const product = this._productService.getProduct();

    const urlSearchParams = new URLSearchParams({
      [QueryStringParameterKey.APPLICATION_ID]:
        SignDocumentUrlVariables.APPLICATION_ID,
    });

    const declineExitPointUrl = this._urlService.createAbsoluteUrlByPage(
      product,
      Page.APPLICATION_DIGITAL_SIGNATURE_DECLINED,
      CustomQueryParamsHandling.REPLACE,
      urlSearchParams,
    );

    return declineExitPointUrl;
  }

  createApplicationQrCodeUrl() {
    const product = this._productService.getProduct();

    const urlSearchParams = new URLSearchParams({
      [QueryStringParameterKey.APPLICATION_ID]:
        SignDocumentUrlVariables.APPLICATION_ID,
    });

    const applicationCrCodeUrl = this._urlService.createAbsoluteUrlByPage(
      product,
      Page.APPLICATION_DIGITAL_SIGNATURE_AUTOMATIC_REDIRECT,
      CustomQueryParamsHandling.REPLACE,
      urlSearchParams,
    );

    return applicationCrCodeUrl;
  }
}

enum SignDocumentUrlVariables {
  APPLICATION_ID = "$applicationId",
}
